import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const testimonials = [
  {
    name: 'Júlia Mendes',
    role: 'Criadora de Conteúdo',
    image: 'https://images.unsplash.com/photo-1698760042584-20ec778e665b?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    content: 'As ideias do Kontty são tão boas que meus seguidores acham que eu contratei uma equipe gigante kkkkkkk. Meu conteudo ta muito bom!',
    rating: 5
  },
  {
    name: 'Rafael Costa',
    role: 'Consultor de Marketing',
    image: 'https://images.unsplash.com/photo-1457986733641-0abe2c60c512?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    content: 'Economizei tanto tempo com o Kontty e tipo meu conteúdo tá crescendo muito! Essa demo tá maravilhosa, tô muito animado pra comprar os planos quando lançar oficialmente!',
    rating: 5
  },
  {
    name: 'Mariana Costa',
    role: 'Influenciadora Digital',
    image: 'https://images.unsplash.com/photo-1581342997451-0215a38cf1cf?q=80&w=1922&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    content: 'O plano personalizado de conteúdo esta me ajudando muito pra crescer meu canal! Economizo horas de planejamento e consigo manter uma presença consistente nas redes sociais. Valeu demais Kontty!',
    rating: 5
  },
  {
    name: 'Pedro Oliveira',
    role: 'Influenciador Social',
    image: 'https://images.unsplash.com/photo-1533265399983-d8af79e01427?q=80&w=1965&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    content: 'Gostei bastante da plataforma, ela tem muito potencial. Dá pra ver que é só o começo, porque ainda é uma demo né? Algumas coisas precisam ser ajustadas, mas já tô curtindo usar. Com certeza vou assinar quando os planos forem lançados',
    rating: 4
  }
];

export default function Testimonials() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/dashboard/ideias');
  };

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      {/* Introduction */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-12 h-12 rounded-lg bg-yellow-100 dark:bg-yellow-900/50 flex items-center justify-center">
            <Star className="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Depoimentos Kontty
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Histórias de sucesso dos nossos usuários
            </p>
          </div>
        </div>

        <div className="prose dark:prose-invert max-w-none">
          <p>
            Descubra como outros criadores estão transformando sua presença online
            usando a Kontty. Aqui estão algumas histórias inspiradoras dos nossos usuários.
          </p>
        </div>
      </div>

      {/* Success Stories */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
          Histórias de Sucesso
        </h2>

        <div className="space-y-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg"
            >
              <div className="flex items-center space-x-4 mb-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <h3 className="font-medium text-gray-900 dark:text-white">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {testimonial.role}
                  </p>
                </div>
                <div className="flex ml-auto">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className={`h-5 w-5 ${
                        i < testimonial.rating
                          ? 'text-yellow-400 fill-current'
                          : 'text-gray-300 dark:text-gray-600'
                      }`}
                    />
                  ))}
                </div>
              </div>
              <div className="relative">
                <Quote className="absolute -left-2 -top-2 h-6 w-6 text-indigo-100 dark:text-gray-600" />
                <p className="text-gray-600 dark:text-gray-300 pl-6">
                  {testimonial.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Statistics */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
          Impacto Kontty
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg text-center">
            <p className="text-3xl font-bold text-indigo-600 dark:text-indigo-400">300%</p>
            <p className="text-gray-600 dark:text-gray-400">Aumento médio de engajamento</p>
          </div>
          <div className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg text-center">
            <p className="text-3xl font-bold text-indigo-600 dark:text-indigo-400">15h</p>
            <p className="text-gray-600 dark:text-gray-400">Economia semanal de tempo</p>
          </div>
          <div className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg text-center">
            <p className="text-3xl font-bold text-indigo-600 dark:text-indigo-400">10k+</p>
            <p className="text-gray-600 dark:text-gray-400">Criadores satisfeitos</p>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm text-center">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
          Faça Parte dessa História
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Junte-se a milhares de criadores que já estão transformando sua presença online com a Kontty
        </p>
        <button 
          onClick={handleGetStarted}
          className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
        >
          Comece Agora com a nossa Demo
        </button>
      </div>
    </div>
  );
}